import { SegmentPageProperties, SegmentTagV2 } from '../shared/analytics/models/segment-tag.model'
import { Injectable } from '@angular/core'
import { SegmentService } from '../shared/analytics/services/segment.service'
import {
  DEFAULT_OG_IMAGE_HEIGHT,
  DEFAULT_OG_IMAGE_WIDTH,
  PageMetaService,
  removeTrailingSlash
} from '../libs/page-meta/page-meta.service'
import { VerticalService } from '../singleton-services/vertical.service'
import { take } from 'rxjs/operators'

export const RANKINGS_LIST: SegmentTagV2 = {
  page_category: 'Rankings',
  category: 'Rankings',
  autoPageCall: false
}

@Injectable()
export class RankingsAnalyticsService {
  public constructor(
    private readonly segment: SegmentService,
    private readonly pageMeta: PageMetaService,
    private readonly vertical: VerticalService
  ) {}

  public sendListPageCall(tag: SegmentTagV2, pageProperties: SegmentPageProperties = { _tag: 'list' }): void {
    this.segment.pageV2(tag, pageProperties)
  }

  public setPageMeta(): void {
    this.vertical.siteSettings$.pipe(take(1)).subscribe(settings => {
      const canonicalUrl = settings.core_site_url ? `${removeTrailingSlash(settings.core_site_url)}/rankings` : ''
      const title = settings.meta_ranking_page_title ?? ''

      this.pageMeta.setPageMeta({
        type: 'website',
        twitterCard: 'summary_large_image',
        title,
        description: settings.meta_ranking_page_description ?? '',
        canonicalUrl,
        siteName: settings.site_name,
        image: {
          url: settings.meta_default_image ?? '',
          height: DEFAULT_OG_IMAGE_HEIGHT,
          width: DEFAULT_OG_IMAGE_WIDTH
        }
      })
    })
  }

  public removePageMeta = () => {
    this.pageMeta.clearMeta()
  }
}
